// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-7f095428]::-webkit-outer-spin-button,\ninput[data-v-7f095428]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-7f095428] {\n  -moz-appearance: textfield;\n}\n.patient-info-edit > a[data-v-7f095428] {\n  color: #984422;\n}\n.shaded[data-v-7f095428] {\n  background-color: #eee !important;\n}", ""]);
// Exports
module.exports = exports;
